import { useEffect } from 'react';

export const useUptimeData = getUptimeRequest => {
    useEffect(() => {
        const timer = setInterval(() => getUptimeRequest(), 1e4);

        return () => clearInterval(timer);
    }, []);
};
